import { TypeStickyCartV2Fields } from '@/contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

import StickyCartV2 from './StickyCartV2'

const ContentfulCart = withContentful<TypeStickyCartV2Fields>(StickyCartV2, {
  stickyNav: (props) => {
    return <BlockRenderer block={props.fields.stickyNav} />
  },
  planCardSection: (props) => {
    return <BlockRenderer block={props.fields.planCardSection} />
  },
  cart: (props) => {
    return <BlockRenderer block={props.fields.cart} />
  },
  heroImage: (props) => {
    return <BlockRenderer block={props.fields.heroImage} />
  },
})

export default ContentfulCart
